import style from "./Shortcuts.module.css";

function ShortCuts() {
  return (
    <div>
      <h2 className={style.shortcutHeader}>Your Shortcuts</h2>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>Elzero Web School</h2>
      </div>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>Web Design</h2>
      </div>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>Javascript Bootcamp</h2>
      </div>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>React Js</h2>
      </div>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>Elzero Web School</h2>
      </div>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>Web Design</h2>
      </div>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>Javascript Bootcamp</h2>
      </div>
      <div className={style.shortcut}>
        <div className={style.shortcutPic}>
          <img src="/Images/Elzero Web School.jpg" alt="Shortcut" />
        </div>
        <h2 className={style.shortcutName}>React Js</h2>
      </div>
    </div>
  );
}

export default ShortCuts;
